<template>
  <div class="article-detail">
    <h4 class="title">{{ articleDetail.title }}</h4>
    <div class="publish-wrapper">
      <img class="publish-img" src="~@/assets/image/gscb_logo.png" alt="" />
      <div class="publish-content">
        <span>广视采编</span>
        <span>{{ articleDetail.createTime }}</span>
      </div>
    </div>
    <div class="intro" v-if="articleDetail.absTract">
      <di v-html="articleDetail.absTract"></di>
    </div>
    <div
      id="content"
      class="content"
      v-html="articleDetail.content"
      @click="handleClickContent"
    ></div>
    <div class="info-name">{{ articleDetail.reporterName }}</div>
    <div class="info-name">{{ articleDetail.messenger }}</div>
    <div class="info-name">{{ articleDetail.editorName }}</div>
    <div class="info-name">{{ articleDetail.from }}</div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import dailyCount from "@/utils/dailyCount.js";
import {
  getGscbArticle,
  getCookie,
  clickRecord,
  queryOperateBtn,
} from "@/http/api";
import ZMYDataCollection from "@/utils/zmy.js";
import Cookies from "js-cookie";
export default {
  name: "GscbArticle",
  data() {
    return {
      imgList: [],
      operateId: null,
      articleDetail: {},
    };
  },
  async mounted() {
    if (Cookies.get("ticket-id")) {
      this.init();
    } else {
      await getCookie({ ticket: "" }).then((ticketId) => {
        console.log("ticketId", ticketId);
        this.ticketId = ticketId;
        this.init();
      });
    }
    ZMYDataCollection.init({
      tenant_code: "prod-gzgb-6b45b19f05d3b092013fd6",
      key: "wJT7EOgGmpHClezJ2qgb1nE60RgVUnrX",
      domain: "rmapi.nfzmy.com",
      debug: "false",
    });
  },
  updated() {
    let obj = document.getElementById("content");
    let imgs = obj.getElementsByTagName("img");
    if (imgs.length > 0) {
      this.imgList = [];
      for (let i = 0; i < imgs.length; i++) {
        this.imgList.push(imgs[i].src);
      }
    }
  },
  methods: {
    async init() {
      console.log(this.$route.path);
      let path = this.$route.path;
      let pathArr = path.split("/");
      this.operateId = pathArr[pathArr.length - 1];

      await this.getArticleDetail();

      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = require("@/assets/image/gscb_logo.png");
      document.getElementsByTagName("head")[0].appendChild(link);

      ZMYDataCollection.openArticle({
        article_id: this.articleDetail.manuId,
        platform: "Mobile",
      });
      this.getPermiBtn();
      this.recordData();
    },
    async getArticleDetail() {
      const { data } = await getGscbArticle(this.operateId);
      data.absTract = data.absTract ? data.absTract.trim() : null;
      this.articleDetail = data;
      document.title = this.articleDetail.title
        ? this.articleDetail.title
        : "花城+";
      if (data.isGray == 1) {
        import("@/assets/scss/grayfilter.css");
      }
    },
    handleClickContent(e) {
      if (e.target.nodeName === "IMG") {
        let handleImgIndex = this.imgList.findIndex((value) => {
          return value === e.target.src;
        });
        ImagePreview({
          images: this.imgList,
          startPosition: handleImgIndex,
        });
      }
    },
    async recordData() {
      await clickRecord({
        deviceId: "1",
        operateId: this.articleDetail.manuId,
        operateType: 1,
        web: 1,
      });
    },

    async getPermiBtn() {
      const { data } = await queryOperateBtn({
        operateId: this.articleDetail.manuId,
        operateType: 1,
      });
    },
    wxShare() {
      const _detail = this.articleDetail;
      let sharePic = `${process.env.VUE_APP_SHARE_URL}/filedata/default/hcplusIcon.jpg`;
      if (_detail.banner != null && _detail.banner !== "") {
        sharePic = _detail.banner;
      }
      wxSdk.getJSSDK({
        title: _detail.title,
        desc: _detail.absTract ? _detail.absTract : "花城+",
        linkurl: `${process.env.VUE_APP_SHARE_URL}/plusshare/#/articleDetail?id=${_detail.manuId}`,
        img: sharePic,
        operateId: this.id,
        operateType: 1,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.article-detail {
  position: relative;
  box-sizing: border-box;
  padding: 0 15px;
  margin-top: 10px;
  width: 100%;
  overflow: hidden !important;
  font-size: 18px;
  font-family: FZBiaoYaSong-GBK_YS !important;
  .title {
    font-size: 1.35rem;
    font-weight: 600;
    line-height: 1.65;
    text-align: left;
    font-family: Microsoft YaHei !important;
  }

  .publish-wrapper {
    display: flex;
    height: 42px;
    margin-top: 15px;

    .publish-img {
      width: 42px;
      height: 42px;
      border-radius: 50%;
    }

    .publish-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 10px;
      font-size: 14px;
      box-sizing: border-box;
      padding: 2px 0;
    }
  }

  .intro {
    position: relative;
    background: #f9f9f9;
    font-size: 14px;
    padding: 15px;
    margin: 10px 0;
    border-radius: 4px;
    color: #bbb;
    box-sizing: border-box;

    &::before {
      position: absolute;
      content: "“";
      top: 0;
      left: 0;
      transform: translate(-30%, -20%);
      font-size: 32px;
      color: #bcd7e4;
      font-weight: bold;
      font-family: SimHei;
    }

    &::after {
      position: absolute;
      content: "”";
      bottom: 0;
      right: 0;
      transform: translate(30%, 75%);
      font-size: 32px;
      color: #bcd7e4;
      font-weight: bold;
      font-family: SimHei;
    }
  }

  .content {
    overflow-x: hidden;
    margin-top: 10px;
    width: 100%;
  }
  .content p {
    line-height: 1.75;
    margin: 0;
    padding-bottom: 1em;
  }
  * {
    box-sizing: border-box;
  }
  .info-name {
    margin-top: 5px;

    &:last-child {
      margin-bottom: 20px;
    }
  }

  .thumbs-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    right: 20px;
    bottom: 50px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 1px 3px 6px #bbb;
    color: #fff;
    font-size: 34px;
    z-index: 9999;
    cursor: pointer;

    .praise-num {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(25%, -25%);
      /* background: rgba(231, 56, 40, 0.6); */
      background: #bbb;
      padding: 0 8px;
      height: 20px;
      border-radius: 10px;
      font-size: 12px;
      color: #fff;
    }
  }

  @media screen and (min-width: 768px) {
    .thumbs-wrapper {
      left: 50%;
      transform: translateX(290px);
    }
  }
}
</style>
